import React from "react";
import {
    VendorFolderSvg,
    VendorChevronRightSvg,
} from "../../../components/CommonSvg";

const DocumentFolders = ({ categories, counts, totalFiles, loading, onOpen }) => (
    <div className="vp-folders">
        {totalFiles > 0 && (
            <button
                type="button"
                className="vp-folder vp-folder-all"
                onClick={() => onOpen("")}
            >
                <span className="vp-folder-icon">
                    <VendorFolderSvg size={17} />
                </span>
                <span className="vp-folder-meta">
                    <span className="vp-folder-name">All Documents</span>
                    <span className="vp-folder-count">
                        {totalFiles === 1 ? "1 file" : `${totalFiles} files`}
                    </span>
                </span>
                <VendorChevronRightSvg />
            </button>
        )}

        {categories.map((folder) => {
            const files = Number(counts[folder.id] || 0);
            return (
                <button
                    type="button"
                    key={folder.id}
                    className="vp-folder"
                    onClick={() => onOpen(folder.id)}
                >
                    <span className="vp-folder-icon">
                        <VendorFolderSvg size={17} />
                    </span>
                    <span className="vp-folder-meta">
                        <span className="vp-folder-name">{folder.name}</span>
                        <span className="vp-folder-count">
                            {files === 1 ? "1 file" : `${files} files`}
                        </span>
                    </span>
                    <VendorChevronRightSvg />
                </button>
            );
        })}

        {categories.length === 0 && (
            <div className="vp-dempty">
                {loading ? "Loading folders…" : "No folders configured yet."}
            </div>
        )}
    </div>
);

export default DocumentFolders;
